import React from 'react';

// Types
import { User } from 'Shared/constants/types';

// Hooks
import { useBaTracking } from 'Shared/tracking/use-ba-tracking';
import { useCreateOrSendBa } from 'Shared/utils/hooks/use-create-or-send-ba';

// Components
import BaseCta from './BaseCta';

//Types
import { Illustrations } from 'Wpds/components/illustration';

type Props = {
  user: User;
};

const ResendBa = ({ user }: Props) => {
  const { trackSendAssessmentButtonClick } = useBaTracking();
  const { resendBaEmail, isCreatingBaLink } = useCreateOrSendBa({ user: user, isTakingBaForSelf: false });

  const handleButtonClick = async () => {
    trackSendAssessmentButtonClick();
    await resendBaEmail();
  };

  return (
    <BaseCta
      title={`Pending assessment completion.`}
      illustration={Illustrations.hourglass}
      illustrationName="hourglass"
      description={`Once ${user.firstName} completes the assessment, you'll see their results here.`}
      buttonText="Resend the assessment"
      buttonVariant="secondary"
      footerText="Learn More"
      showDivider={false}
      showExternalLink={false}
      buttonConfirmationText="Need to resend?"
      buttonSize="md"
      onButtonClick={handleButtonClick}
      loading={isCreatingBaLink}
    />
  );
};

export default ResendBa;
